import { Spinner } from '@chakra-ui/react';
import { useState } from 'react';

import { apiSensedia } from '../../../../../services/api-sensedia';
import { TableOffersType } from '../types/MovimentacaoFundosType';
import { OfferRow } from './OfferRow';
import { PaginationTableOffers } from './PaginationTableOffers';

export const TableOffers = ({
  dataTable,
  dataPagination,
  handleSelectOffers
}: TableOffersType) => {
  return (
    <div className="tw-h-full tw-flex tw-flex-col tw-justify-between">
      <table className="tw-w-full">
        <thead>
          <tr className="tw-text-left ">
            <th className="tw-text-blue-900 tw-font-bold tw-px-4 tw-pb-3">
              <span className="tw-text-blue-900 ">Nome</span>
            </th>
            <th className="tw-text-blue-900 tw-font-bold tw-px-4 tw-pb-3">
              <span className="tw-text-blue-900">CPF</span>
            </th>
            <th className="tw-text-blue-900 tw-font-bold tw-px-4 tw-pb-3">
              <span className="tw-text-blue-900">Proposta</span>
            </th>
            <th className="tw-text-blue-900 tw-font-bold tw-px-4 tw-pb-3">
              <span className="tw-text-blue-900">Produto</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {dataTable?.map((row, index) => (
            <OfferRow
              key={index}
              index={index}
              row={row}
              handleSelectOffers={handleSelectOffers}
            />
          ))}
        </tbody>
      </table>
      <PaginationTableOffers dataPagination={dataPagination} />
    </div>
  );
};
